<template>
  <div class="new">
    <!-- <navigator class='header' title="发布话题" :routePath='"/bbs/blogList"'></navigator> -->

    <mt-field class='title' placeholder="请填写标题" v-model="article.title"></mt-field>

    <div class="avatar_wrap">
      <mt-cell class='cell_nomarginpadding' title="添加封面图片"></mt-cell>
      <van-uploader :after-read="onRead">
        <div class="box" v-if='!article.cover'>
          <i class="iconfont icon-shangchuantupian"></i>
        </div>
        <img v-else :src="article.cover" class="success">
      </van-uploader>
    </div>

    <div class="content_wrap">
      <mt-cell class='cell_nomarginpadding' title="编辑内容"></mt-cell>
      <mt-field class='cell_nomarginpadding cell_border' placeholder="编辑内容" type="textarea" rows="4" v-model="article.content"></mt-field>
    </div>

    <van-cell class='bbs_protocol'>
      <template slot="title">
        <van-checkbox v-model="isAgree">同意天安智慧云<span class="protocol_link" @click.stop='showProtocol'>《发帖规则》</span></van-checkbox>
      </template>
    </van-cell>

    <div class="footer">
      <van-button class='save' text='发布' @click='publish' :disabled='!isAgree'/>
    </div>

  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { Toast } from 'vant';

export default {
  data() {
    return {
      article: {
        title: '',
        cover: '',
        content: '',
      },
      qiniuConfig: {},
      duration: 1500,
      isAgree: false,
    };
  },
  methods: {
    // 获取七牛配置
    getUploadToken() {
      this.$http.post(`${this.URL_PREFIX}/app/get/qiniu/bucket/token`, {}, {
        headers: { token: localStorage.getItem('swtoken') },
      }).then((response) => {
        const res = response.data;
        if (res.resCode === '10000') {
          this.qiniuConfig = res.resData;
        }
      });
    },
    // 上传
    onRead(uploader) {
      let param = new FormData();
      param.append('file', uploader.file);
      param.append('token', this.qiniuConfig.token);
      let config = {
        headers:{'Content-Type':'multipart/form-data'}
      };
      this.$http.post('http://up-z2.qiniup.com/', param, config).then((response) => {
        const res = response.data;
        this.article.cover = `${this.qiniuConfig.domain}/${res.key}`;
      });
    },
    // 发表
    publish() {
      // if (!this.article.title) {
      //   Toast.fail({ duration: this.duration, message:  '请输入标题'});
      //   return;
      // }
      // if (!this.article.cover) {
      //   Toast.fail({ duration: this.duration, message:  '请上传封面'});
      //   return;
      // }
      if (!this.article.content) {
        Toast.fail({ duration: this.duration, message:  '请编辑内容'});
        return;
      }
      this.$http.post(`${this.URL_PREFIX}/app/added/bbs/post`, {
        parkId: this.currentParkId,
        // orderId:parseInt(location.href.split('orderId=')[1]?location.href.split('orderId=')[1]:null),
        siteId: location.href.split('siteId=')[1],
        subject: this.article.title,
        thumb: this.article.cover,
        content: this.article.content,
      }, {
        headers: { token: localStorage.getItem('swtoken') }
      }).then((response) => {
        const res = response.data;
        if (res.resCode === '10000') {
          const id = res.resData.id;
          // this.$router.push(`/bbs/detail/${id}`);
          window.location.href = `${this.URL_PREFIX_PAGE}/bbs/detail/${id}?orderId=${location.href.split('orderId=')[1]}`;
        } else {
          Toast.fail({ duration: this.duration, message:  res.resDesc});
        }
      });
    },
    // 查看发帖协议
    showProtocol() {
      this.$router.push('/bbs/publish/protocol');
    },
  },
  computed: {
    ...mapGetters(['token', 'currentParkId']),
  },
  created() {
    this.getUploadToken();
    // if (!this.token) {
    //   this.$root.eventHub.$emit('login', this.$route.fullPath);
    // } else {
    //   this.getUploadToken();
    // }
  },
};
</script>

<style lang="scss" scoped>
@import '~@scss';
.new{
  padding-bottom: 1.2rem;
  .title{
    margin-bottom: .133333rem;
  }
  .avatar_wrap{
    padding: 0 .32rem .32rem .32rem;
    margin-bottom: .266667rem;
    background: #fff;
    .box{
      width: 2.24rem;
      height: 2.24rem;
      border: 1px solid rgb(200, 200, 200);
      line-height: 2.24rem;
      text-align: center;
      .iconfont{
        font-size: .8rem;
        color: rgb(200, 200, 200);
      }
    }
    .success{
      width: 2.24rem;
      height: 2.24rem;
    }
  }
  .content_wrap{
    padding: .32rem;
    background: #fff;
  }
  .bbs_protocol{
    background: #fff;
    margin-top: .133333rem;
    .protocol_link{
      color: $color-main;
    }
  }

   .footer{
    position: fixed;
    padding: .133333rem .426667rem;
    box-sizing: border-box;
    left: 0;
    bottom: 0;
    width: 100%;
    background: rgb(235, 235, 235);
    .save{
      padding: 0;
      width: 100%;
      height: 1.066667rem;
      line-height: 1.066667rem;
      background: $color-main;
      border: none;
      color: #fff;
      &.van-button--disabled{
        background: #2b343b;
      }
    }
  }

   .mint-field, .mint-cell{
    font-size: .4rem;
    color: rgb(67, 67, 67);
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/bbs/components/Publish.vue